/**
 * ErpGuideTab — zakładka „Instrukcja" ekranu Integracja ERP.
 *
 * Statyczny przewodnik krok-po-kroku konfiguracji integracji z Symfonia WebAPI.
 * Zero API — sama treść z i18n. Prezentacja jako prosta lista sekcji (`<section>`
 * z nagłówkiem + treścią), bez akordeonu (repo nie ma prymitywu Accordion).
 */

import { useTranslation } from 'react-i18next';

const PREFIX = 'tenant.settings.integrations.guide';

export function ErpGuideTab() {
  const { t } = useTranslation();

  const prereqs = [
    t(`${PREFIX}.prereq1`),
    t(`${PREFIX}.prereq2`),
    t(`${PREFIX}.prereq3`),
    t(`${PREFIX}.prereq4`),
  ];

  const steps = [
    { title: t(`${PREFIX}.step1title`), body: t(`${PREFIX}.step1body`) },
    { title: t(`${PREFIX}.step2title`), body: t(`${PREFIX}.step2body`) },
    { title: t(`${PREFIX}.step3title`), body: t(`${PREFIX}.step3body`) },
    { title: t(`${PREFIX}.step4title`), body: t(`${PREFIX}.step4body`) },
    { title: t(`${PREFIX}.step5title`), body: t(`${PREFIX}.step5body`) },
    { title: t(`${PREFIX}.step6title`), body: t(`${PREFIX}.step6body`) },
  ];

  return (
    <div className="space-y-8">
      <header>
        <h3 className="text-base font-semibold text-text-primary">{t(`${PREFIX}.title`)}</h3>
        <p className="mt-1 text-sm text-text-secondary">{t(`${PREFIX}.intro`)}</p>
      </header>

      <section>
        <h4 className="mb-2 text-sm font-semibold text-text-primary">
          {t(`${PREFIX}.prereqTitle`)}
        </h4>
        <ul className="list-disc space-y-1 pl-5 text-sm text-text-secondary">
          {prereqs.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </section>

      <section>
        <h4 className="mb-3 text-sm font-semibold text-text-primary">
          {t(`${PREFIX}.stepsTitle`)}
        </h4>
        <ol className="space-y-4">
          {steps.map((step, i) => (
            <li
              key={i}
              className="flex gap-3 rounded-md border border-border-primary bg-bg-secondary p-4"
            >
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-600 text-xs font-semibold text-white">
                {i + 1}
              </span>
              <div className="min-w-0">
                <div className="text-sm font-medium text-text-primary">{step.title}</div>
                <p className="mt-1 text-sm text-text-secondary">{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
}
